export default __webpack_public_path__ + "static/fluo-foundation-54305412c392eccc4d11c8c365e9c5b0.png";